(function () {
    'use strict';

    angular.module("imApp").factory("labourPositionsService", ['$ihttp', function ($ihttp) {
        let service = {
            getLabourPositions: function (parms) {
                return $ihttp.post({
                    method: 2561,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
